export const ROUTE_PATH = '/product-arrangement';

export const PATCH_URL = '/product/';
